import { cn } from 'common/utils'
import OpenGraph from './OpenGraph'
import { AlertIcon, NoResultsIcon } from 'cc/icons'

export const EmptyPage = ({ title, full, ...props }) => (
  <div
    className={full ? 'h-full flex flex-col justify-center items-center' : null}
  >
    <OpenGraph pageTitle={title || 'No Results'} />
    <EmptySection title={title} alert {...props} />
  </div>
)

export const EmptySection = ({
  title,
  children,
  className,
  alert,
  ...props
}) => {
  const Icon = alert ? AlertIcon : NoResultsIcon
  return (
    <div
      className={cn(
        alert ? 'text-yellow-900 bg-yellow-50' : 'text-gray-500 bg-gray-50',
        'flex flex-col rounded pb-10 w-full text-center mb-3 text-lg font-light shadow-inner',
        className,
      )}
      {...props}
    >
      <Icon
        className={cn(
          'w-10 h-10 mx-auto mb-5 mt-10',
          alert ? 'text-yellow-500' : 'text-gray-500',
        )}
      />
      {title}
      {children}
    </div>
  )
}
